import config from "../../config";

const base = config.api.baseUrl;

const opts = (extra = {}) => ({
  credentials: "include",
  headers: { "Content-Type": "application/json" },
  ...extra,
});

const handle = async (resp) => {
  let data = null;
  try { data = await resp.json(); } catch (_) { /* not json */ }
  if (!resp.ok || (data && data.success === false)) {
    const err = new Error((data && data.error) || `HTTP ${resp.status}`);
    err.status = resp.status;
    throw err;
  }
  return data;
};

export const api = {
  adminUsage: async (days = 30) => {
    const r = await fetch(
      `${base}${config.api.endpoints.chatbot.adminUsage}?days=${days}`, opts());
    return await handle(r); // { by_day, by_user, by_chatbot, totals, days }
  },
  adminMessages: async (userEmail, { q = "", limit = 50, before = null } = {}) => {
    const params = new URLSearchParams({ user_email: userEmail, limit: String(limit) });
    if (q) params.set("q", q);
    if (before) params.set("before", before);
    const r = await fetch(
      `${base}${config.api.endpoints.chatbot.adminMessages}?${params}`, opts());
    return await handle(r); // { messages, next_before }
  },
};
